<template>
  <v-layout justify-center class="pagemargin page">
    <v-flex xs12 sm6 md3>
    <notifications group="email" position="top center"/>
    <p class="mt-4">
      <center>Please enter your email address to request a password reset.</center>
    </p>
    <v-form>
      <v-text-field
        v-model.trim="email"
        label="Email"
        solo
        data-vv-name="email"
        v-validate="'required|max:30'"
        :error-messages="errors.collect('email')"
        required
      ></v-text-field>
      <p class="mt-4">
        <center>
          <v-btn
            :disabled="errors.any()"
            @click="resetPassword"
            round
            block
            color="primary"
            class="caption font-weight-light"
          >Reset Password</v-btn>
        </center>
      </p>
    </v-form>
    {{portal.active}}
    </v-flex>
    </v-layout>
</template>


<script>
import Vue from "vue";
import { mapState } from "vuex";
import axios from 'axios';

export default {
  data() {
    return {
      email: ""
    }
  },
  name: "home",
  computed: {
    ...mapState({
      FirebaseFunctionsURL: state => state.FirebaseFunctionsURL,
      portal: state => state.portal
    })
  },
  methods: {
    resetPassword: function() {
      axios
        .get(
          this.FirebaseFunctionsURL +
            "sendResetPasswordEmail?userEmail=" +
            this.email +
            "&pid=" +
            this.portal.active.id
        )
        .then(response => {
          //console.log("RESULT: " + JSON.stringify(response, null, 2));
          //console.log(response.data.result);
          if (response.data.result === true) {
            Vue.notify({
              group: "email",
              title: "Success",
              text: "Email sent",
              type: "success"
            })
            //this.$Console.log("Email sent");
          } else {
            Vue.notify({
              group: "email",
              title: "Error",
              text: "The email is not valid",
              type: "error"              
            })
            //this.$Console.log("Something went wrong");
          }
        });
    }
  }
};
</script>